import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScLogin = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;

  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 8px 0;

    & > button {
      position: fixed;
    }
  }
`;

export const ScLoginContent = styled.div`
  position: relative;
  padding: 32px 32px 0;
  border-radius: 24px;
  color: ${({ theme }) => theme.blackColor};
  background: ${({ theme }) => theme.whiteColor};
  width: 100%;

  @media (${device.mobile}) {
    padding: 32px 16px 0 16px;
    margin: 0 8px 16px;
  }

  h2 {
    font-weight: bold;
    text-align: center;

    text-transform: uppercase;
    color: ${({ theme }) => theme.blackColor};
    margin-bottom: 32px;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.96px;
  }

  & > span {
    display: inherit;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 32px;
    color: ${({ theme }) => theme.mainColor};
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }

  & > h3 {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    margin-bottom: 32px;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileXS}) {
      margin-bottom: 16px;
      font-size: 28px;
    }
  }

  .avatar {
    width: 96px;
    height: 96px;
    margin: 32px auto 16px;
  }

  .login {
    display: flex;
    justify-content: center;
    & > button {
      margin-top: 16px;
      display: flex;
      align-items: center;
      gap: 4px;

      span {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
      svg {
        transform: rotate(90deg);
        path {
          stroke: ${({ theme }) => theme.secondaryColor};
        }
      }
    }
  }
`;

export const ScLoginWrapButtons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 32px;

  .recovery-btn {
    font-size: 16px;
    line-height: 24px;
    color: #8e8e93;
    margin-top: 16px;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.blackColor};
      }
    }
  }
`;

export const ScLoginInfo = styled.div`
  text-align: center;

  margin: 32px -32px 0 -32px;
  padding: 12px;
  font-size: 16px;
  line-height: 24px;
  background-color: ${({ theme }) => theme.gray1Color};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;

  button {
    min-width: auto;
    padding: 0 13px 0 0;
    overflow: visible;

    .text {
      font-weight: 700;

      font-size: 16px;
      line-height: 24px;
    }

    .awareWrap {
      display: none;
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 6px;
      height: 100%;
      background-color: ${({ theme }) => theme.secondaryColor};
      -webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDYgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA2TDEgMTEiIHN0cm9rZT0iIzI1QUFENiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==);
      mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDYgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA2TDEgMTEiIHN0cm9rZT0iIzI1QUFENiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==);
      mask-size: contain;
      -webkit-mask-size: contain;
      mask-repeat: no-repeat;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center;
      mask-position: center;
      transition: all 0.3s;
    }

    @media (hover: hover) {
      &:hover {
        &::after {
          background-color: ${({ theme }) => theme.secondaryColorHover};
          right: -3px;
        }
      }
    }
  }
  @media (${device.mobile}) {
    margin: 32px -16px 0 -16px;
  }
`;
